import WeatherCardSmall from '@/page/growth/dashboard/WeatherCardSmall';
import WeatherCard, { WeatherData } from '@/page/growth/dashboard/WeatherCard';
import Chart27 from './Chart27';

const Chart1 = () => {
    const weeklyForecast: WeatherData[] = [
        {
            weatherIdx: 6,
            date: '2025-01-06',
            dayOfWeek: '월요일',
            weatherAm: '구름많고 비/눈',
            weatherPm: '구름많고 소나기',
            rainRateAm: 75,
            rainRatePm: 65,
            minTemp: -1,
            maxTemp: 4,
            rainfall: 6.8,
            humidity: 75,
        },
        {
            weatherIdx: 7,
            date: '2025-01-07',
            dayOfWeek: '화요일',
            weatherAm: '흐리고 비',
            weatherPm: '흐리고 비',
            rainRateAm: 90,
            rainRatePm: 85,
            minTemp: 7,
            maxTemp: 13,
            rainfall: 25.4,
            humidity: 88,
        },
        {
            weatherIdx: 8,
            date: '2025-01-08',
            dayOfWeek: '수요일',
            weatherAm: '흐리고 눈',
            weatherPm: '흐리고 눈',
            rainRateAm: 95,
            rainRatePm: 90,
            minTemp: -8,
            maxTemp: -2,
            rainfall: 18.7,
            humidity: 85,
        },
        {
            weatherIdx: 9,
            date: '2025-01-09',
            dayOfWeek: '목요일',
            weatherAm: '흐리고 비/눈',
            weatherPm: '흐리고 소나기',
            rainRateAm: 80,
            rainRatePm: 70,
            minTemp: 1,
            maxTemp: 6,
            rainfall: 14.2,
            humidity: 80,
        },
        {
            weatherIdx: 10,
            date: '2025-01-10',
            dayOfWeek: '금요일',
            weatherAm: '비',
            weatherPm: '비',
            rainRateAm: 100,
            rainRatePm: 95,
            minTemp: 8,
            maxTemp: 14,
            rainfall: 32.5,
            humidity: 92,
        },
        {
            weatherIdx: 11,
            date: '2025-01-11',
            dayOfWeek: '토요일',
            weatherAm: '눈',
            weatherPm: '눈',
            rainRateAm: 95,
            rainRatePm: 90,
            minTemp: -12,
            maxTemp: -4,
            rainfall: 22.8,
            humidity: 87,
        },
        {
            weatherIdx: 12,
            date: '2025-01-12',
            dayOfWeek: '일요일',
            weatherAm: '비/눈',
            weatherPm: '비/눈',
            rainRateAm: 85,
            rainRatePm: 80,
            minTemp: -3,
            maxTemp: 3,
            rainfall: 16.3,
            humidity: 83,
        },
    ];

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-4">
                    <WeatherCard
                        weather={{
                            weatherIdx: 1,
                            date: '05.01',
                            dayOfWeek: '수요일',
                            weatherAm: '맑음',
                            weatherPm: '흐리고 비',
                            rainRateAm: 0,
                            rainRatePm: 0,
                            minTemp: -2,
                            maxTemp: 10,
                            rainfall: 0.0,
                            humidity: 45,
                        }}
                    />
                </div>
                <div className="col-12 col-md-8">
                    <div className="card custom-card p-2 weather-card">
                        <div className="card-header">
                            <div className="d-flex justify-content-between w-100">
                                <div>
                                    <h4 className="mb-1">2025년 5월 1일</h4>
                                    <div className="lunar-date text-gray-7">
                                        수요일 | 음력 2025년 4월 13일
                                    </div>
                                    <div className="location text-gray-7">
                                        <i className="bi bi-geo-alt-fill me-1"></i>
                                        충청남도 천안시 동남구 북면 은지리 309-8
                                    </div>
                                </div>
                                <div className="update-time">
                                    <span className="p-1 fs-11 bg-success text-fixed-white text-center rounded-1 lh-1 fw-medium">
                                        <i className="bi bi-arrow-clockwise me-1"></i>
                                        업데이트: 25.05.01 14:30:23
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="card-body weather-info">
                            <div className="row weather-grid">
                                <div className="col-12 col-sm-3 weather-item weather-item-header">
                                    날씨
                                </div>
                                <div className="col-12 col-sm-3 weather-item">
                                    맑음 / 흐리고비
                                </div>
                                <div className="col-12 col-sm-3 weather-item weather-item-header">
                                    현재기온
                                </div>
                                <div className="col-12 col-sm-3 weather-item">
                                    24°C
                                </div>
                            </div>

                            <div className="row weather-grid">
                                <div className="col-12 col-sm-3 weather-item weather-item-header">
                                    최고기온
                                </div>
                                <div className="col-12 col-sm-3 weather-item">
                                    24°C
                                </div>
                                <div className="col-12 col-sm-3 weather-item weather-item-header">
                                    최저기온
                                </div>
                                <div className="col-12 col-sm-3 weather-item">
                                    12°C
                                </div>
                            </div>

                            <div className="row weather-grid">
                                <div className="col-12 col-sm-3 weather-item weather-item-header">
                                    강수확률
                                </div>
                                <div className="col-12 col-sm-3 weather-item">
                                    20%
                                </div>
                                <div className="col-12 col-sm-3 weather-item weather-item-header">
                                    강수량
                                </div>
                                <div className="col-12 col-sm-3 weather-item">
                                    0mm
                                </div>
                            </div>
                            <div className="row weather-grid">
                                <div className="col-12 col-sm-3 weather-item weather-item-header">
                                    일사량
                                </div>
                                <div className="col-12 col-sm-3 weather-item">
                                    6.5 MJ/m²
                                </div>
                                <div className="col-12 col-sm-3 weather-item weather-item-header">
                                    습도
                                </div>
                                <div className="col-12 col-sm-3 weather-item">
                                    55%
                                </div>
                            </div>

                            <Chart27 />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mt-3 ">
                <div className="col-12">
                    <div className="row">
                        {weeklyForecast.map(weather => (
                            <div className="col-12 col-md-4 col-xxl">
                                <WeatherCardSmall
                                    key={weather.weatherIdx}
                                    weather={weather}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart1;
